import React from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import heroBackground from "../../assets/images/hero-background-about.png";
import GeneralClosing from "../../components/general-closing";
import AboutTeam from "./about-team";
import AboutFinancial from "./about-financial";
import { useNavigate } from "react-router";
import { NAVIGATIONS } from "../..";

function About() {
  const navigate = useNavigate();
  return (
    <div className="main-container" id="about-page">
      <div
        className="hero-background-container about-banner position-relative"
        style={{
          backgroundImage: `url(${heroBackground})`,
        }}
      >
        <Container>
          <Row className="text-white justify-content-between">
            <Col sm={12} className="h-100  mt-xl-1 pt-xl-5">
              <div>
                <h1 className="text-size-title-2 fw-extra-bold banner-about-title text-white">
                  Profil
                </h1>
                <div className="mt-2 text-size-body-head-2 text-white">
                  PT Pohon Dana Indonesia adalah Penyelenggara Layanan Pendanaan Bersama Berbasis Teknologi Informasi (LPBBT) 
                  yang telah berizin dan diawasi oleh Otoritas Jasa Keuangan (OJK) berdasarkan surat Keputusan Nomor KEP-126/D.05/2019 
                  serta merupakan anggota aktif dari Asosiasi Fintech Pendanaan Bersama Indonesia (AFPI). Pohon Dana senantiasa 
                  membantu konsumen kami untuk tumbuh bersama dengan memanfaatkan teknologi modern yang mempermudah akses layanan finansial
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <Container className="mb-5 py-5">
        <div className="mb-5">
          <AboutTeam />
        </div>
        <div className="mb-5 py-5">
          <AboutFinancial />
        </div>

        <GeneralClosing
          title="Tumbuh dan Berkembang Bersama Pohon Dana Sekarang!"
          buttonText="Telusuri Produk Kami"
          extraButton={
            <Button
              variant="outline-primary"
              className="ms-4"
              size="lg"
              onClick={() => {
                navigate(NAVIGATIONS.partner);
              }}
            >
              Lihat Peminjam / Mitra Pohon Dana
            </Button>
          }
        />
      </Container>
    </div>
  );
}

export default About;
